module.exports = __webpack_public_path__ + "static/media/arrow-left.cbc58ba1.svg";